import { EnvironmentInjector, Inject, Injectable } from '@angular/core';
import {
	HttpInterceptor,
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(private router: Router, @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector) { }

	intercept(
		request: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(request).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 500 && !request.url.includes("www.nbg.gr")) {
					// Navigate to the error page for all 500 errors
					this.router.navigate([localizeRoute('/error', this.envInjector)]);
				}
				return throwError(() => error);
			})
		);
	}
}
